import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { BlackListService } from 'src/app/services/blacklist/black-list.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { DatePipe } from '@angular/common';
import { IBlackListBase, IBlackListHistoricoParams, IBlackListQueryParams, IBlackListResponse } from 'src/app/services/blacklist/IBlackList';
import { IOptions } from 'src/app/core/types';
import { IDENTIFICADOR_OPTIONS, SITUACAO_OPTIONS } from 'src/app/core/constants/options';
import { SituacaoPipe } from 'src/app/core/pipes/situacao.pipe';
import { IdentificadorPipe } from 'src/app/core/pipes/identificador.pipe';
import { ITableColumn } from 'src/app/core/components/tabela/tabela.model';
import moment from 'moment';
import { validarPermissao } from 'src/app/core/utils/permissionScreen/permissionScreen';
import { IOpcaoAcao, IOpcaoTela } from 'src/app/core/utils/permissionScreen/permissionScreen.types';
import { StatusPipe } from 'src/app/core/pipes/status.pipe';

@Component({
  selector: 'app-listagem-blacklist',
  templateUrl: './listagem-blacklist.component.html',
  styleUrl: './listagem-blacklist.component.scss',
   providers: [SituacaoPipe, IdentificadorPipe, DatePipe, StatusPipe]
})
export class ListagemBlacklistComponent implements OnInit, AfterViewInit {
  // Injeções
  router = inject(Router);
  fb = inject(FormBuilder);
  blacklistService = inject(BlackListService);
  situacaoPipe = inject(SituacaoPipe);
  statusPipe = inject(StatusPipe);
  identificadorPipe = inject(IdentificadorPipe);
  datePipe = inject(DatePipe);
  swalAlert = inject(SwalAlertService);
  cdr = inject(ChangeDetectorRef);

  ////////////////////////////////////////////////////////
  form = this._inicializarFormulario();
  isLoading: boolean = false;
  expandirCardsMobile: boolean = true;
  solicitarAgendamento: boolean = false;
  isHistoricoOpen = false;
  historicoLoading = false;
  /// Strings
  blobUrl: string = '';
  // Numbers
  numeroPagina: number = 0; // 0-based, igual Cavalo
  maxPages: number = 1;
  /// Objetos
  tableData: IBlackListResponse[] | Array<any> = [];
  identificadorOptions: IOptions[] = IDENTIFICADOR_OPTIONS;
  situacaoOptions: IOptions[] = SITUACAO_OPTIONS;
  tableColumns = [
    { header: 'ID', key: 'PK_BLCK_LIST', type: 'text' },
    {
      header: 'Categoria',
      key: 'NU_IDNT_CHVE',
      type: 'text',
      pipe: this.identificadorPipe
    },
    { header: 'Identificador', key: 'TX_IDNT_VALR', type: 'text' },
    {
      header: 'Expira Em',
      key: 'DT_DURC_BLOQ',
      type: 'text'
    },
    {
      header: 'Último Desbloqueio/Supervisão',
      key: 'DT_ULTM_DSBL',
      type: 'text'
    },
    {
      header: 'Situação',
      key: 'NU_TIPO_BLOQ',
      type: 'text',
      pipe: this.situacaoPipe
    },
    {
      header: 'Status',
      key: 'FL_STTS',
      type: 'text',
      pipe: this.statusPipe
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.acaoItem(item, 'Visualizar'),
          condition: (item: any) => true
        },
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.acaoItem(item, 'Editar'),
          condition: (item: any) => true
        },
        {
          label: 'Historico',
          img: 'assets/icons/history.svg',
          action: (item: any) => this.visualizarHistorico(item),
          condition: (item: any) => true
        },
        {
          label: 'Desbloquear',
          img: 'assets/icons/cadeado-icon.svg',
          action: (item: any) => this.PatchBlackListDesbloquear(item),
          condition: (item: IBlackListBase) => item.FL_STTS === 1
        }
      ]
    }
  ];
  viewMenu(menu: IOpcaoTela, acao: IOpcaoAcao): boolean {
    return validarPermissao(menu, acao);
  }
  permitirEditar(item: any): boolean {
    item.PK_BLCK_LIST

    return true;
  }
  historicoColumns: ITableColumn[] = [
    {
      header: 'Evento',
      key: 'NU_TIPO_BLOQ',
      type: 'text',
      pipe: this.situacaoPipe
    },
    { header: 'ID', key: 'PK_BLCK_LIST', type: 'text' },
    {
      header: 'Categoria',
      key: 'NU_IDNT_CHVE',
      type: 'text',
      pipe: this.identificadorPipe
    },
    { header: 'Identificador', key: 'TX_IDNT_VALR', type: 'text' },
    { header: 'Responsável', key: 'responsavel', type: 'text' },
        {
      header: 'Status',
      key: 'FL_STTS',
      type: 'text',
      pipe: this.statusPipe
    },
    {
      header: 'Expira Em',
      key: 'DT_DURC_BLOQ',
      type: 'text'
    }
  ];
  pesquisaParams = {
    TxPesquisar: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 20
  };
  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  historicoRows: any[] = [];

  private _inicializarFormulario(): FormGroup<{
    NU_IDNT_CHVE: FormControl<number | null>;
    NU_TIPO_BLOQ: FormControl<number | null>;
    DT_DURC_BLOQ: FormControl<string | null>;
  }> {
    return this.fb.group({
      NU_IDNT_CHVE: this.fb.control<number | null>(null),
      NU_TIPO_BLOQ: this.fb.control<number | null>(null),
      DT_DURC_BLOQ: this.fb.control<string | null>(null)
    });
  }

  ngOnInit(): void {
    this.getBlackList(this.numeroPagina + 1);
  }

  ngAfterViewInit(): void {
    this.solicitarAgendamento = true;
    this.form.valueChanges.pipe(debounceTime(400)).subscribe(() => {
      this.numeroPagina = 1;
      this.getBlackList(1);
    });
    this.tableColumns.map(column => {
      // if (column.type === 'buttons') {
      //   const buttons = column.buttons;
      //   if (buttons !== undefined) {
      //     buttons.push(
      //       {
      //         label: 'Editar',
      //         img: 'assets/edit.svg'
      //       }
      //     );
      //   }
      // }
    });
  }

  navegarFormulario() {
    this.router.navigate(['cadastro/blacklist']);
  }

  mudarPagina(pageIndex: number) {
    // se o componente emite 0-based:
    this.numeroPagina = pageIndex + 1; // 1-based pra API
    this.pesquisaParams.Pagina = pageIndex; // se você usa 0-based local

    this.getBlackList(this.numeroPagina);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '******';
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '******';
  }
  getBlackList(pagina: number = 1): void {
    this.isLoading = true;

    const payload = this.form.value;
    const params: IBlackListQueryParams = {
      NU_IDNT_CHVE: payload.NU_IDNT_CHVE ?? null,
      NU_TIPO_BLOQ: payload.NU_TIPO_BLOQ ?? null,
      DT_DURC_BLOQ: payload.DT_DURC_BLOQ ?? null,
      PAGE_NUMBER: pagina ?? 1,
      PAGE_SIZE: this.pesquisaParams.TamanhoPagina // ou fixo 5
    };

    this.blacklistService.GetBlackLists(params).subscribe({
      next: (response: IBlackListResponse) => {
        const page = response.BlackLists;
        this.tableData = response.BlackLists.ITEMS.map(item => ({
          PK_BLCK_LIST: item.PK_BLCK_LIST,
          TX_IDNT_VALR: item.TX_IDNT_VALR,
          NU_IDNT_CHVE: Number(item.NU_IDNT_CHVE ?? 1),
          TX_DTLH_BLOQ: item.TX_DTLH_BLOQ,
          DT_DURC_BLOQ: this.getDate(item.DT_DURC_BLOQ as Date),
          DT_ULTM_DSBL: this.getDate(item.DT_ULTM_DSBL as Date),
          NU_TIPO_BLOQ: item.NU_TIPO_BLOQ,
          FL_STTS: item.FL_STTS,
        }));

        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  createPayload() {
    const payload = {
      ...this.form.value
    };
    Object.keys(payload).forEach(key => key === null && delete payload[key]);
    return payload;
  }

  acaoItem(item: any, tipoModo: 'Editar' | 'Visualizar') {
    const queryParams = {
      ...item,
      modo: tipoModo
    };
    this.router.navigate(['cadastro/blacklist'], {
      queryParams: queryParams
    });
  }

  visualizarHistorico(item: any) {
    this.isHistoricoOpen = true;
    this.historicoLoading = true;
    this.historicoRows = [];

    // força angular a “aceitar” o novo estado antes de continuar
    this.cdr.detectChanges();

    const params: IBlackListHistoricoParams = {
      NU_IDNT_CHVE: Number(item.NU_IDNT_CHVE),
      TX_IDNT_VALR: String(item.TX_IDNT_VALR ?? '')
    };

    this.blacklistService.GetBlackListHistorico(params).subscribe({
      next: (res: any) => {
        const list = res?.BlackLists ?? [];

        this.historicoRows = list.map((h: any) => ({
          NU_TIPO_BLOQ: h.NU_TIPO_BLOQ,
          PK_BLCK_LIST: h.PK_BLCK_LIST,
          FL_STTS: h.FL_STTS,
          NU_IDNT_CHVE: h.NU_IDNT_CHVE,
          TX_IDNT_VALR: h.TX_IDNT_VALR,
          TX_DTLH_BLOQ: h.TX_DTLH_BLOQ,
          responsavel: h.NM_FUNC_CRIA ?? '—',
          DT_DURC_BLOQ: this.getDate(new Date(h.DT_DURC_BLOQ))
        }));

        this.historicoLoading = false;

        this.cdr.markForCheck();
      },
      error: () => {
        this.historicoLoading = false;
        this.cdr.markForCheck();
      }
    });
  }
  escolherSelect(
    value: any,
    controlName: keyof typeof this.form.controls
  ): void {
    if (!this.form.controls[controlName]) {
      console.warn(`Control ${controlName} não existe no formulário`);
      return;
    }
    const parsedValue =
      value === '' || value === null || value === undefined
        ? null
        : isNaN(Number(value))
          ? value
          : Number(value);

    this.form.get(controlName)?.setValue(parsedValue);
  }
  PatchBlackListDesbloquear(item: any): void {
    const id = Number(item?.PK_BLCK_LIST ?? item?.id);

    if (!id) {
      this.swalAlert.showAlert(
        'Atenção!',
        'Não foi possível bloquear porque o ID do registro não foi encontrado.',
        'warning',
        true
      );
      return;
    }

    this.swalAlert.showAlert(
      'Confirmar Desbloqueio',
      `Tem certeza que quer desbloquear este registro?`,
      'warning',
      true,
      true,
      {
        confirmButtonText: 'Sim, desbloquear',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#B91C1C',
        cancelButtonColor: '#64748B'
      },
      () => {
        this.historicoLoading = true;

        this.blacklistService
          .PatchBlackListDesbloquear(id.toString())
          .subscribe({
            next: () => {
              this.historicoLoading = false;

              this.swalAlert.showAlert(
                'Sucesso!',
                'Pessoa bloqueada com sucesso.',
                'success',
                true
              );

              this.getBlackList();
            },
   
            complete: () => {
  this.historicoLoading = false;
            }
          });
      }
    );
  }

  escolherServico(value: any): void {}

  cancelamentoStatus(item: any): boolean {
    const invalid = ['Encerrado', 'Bloqueado', 'Supervisão'];

    if (invalid.includes(item.situacao)) return false;

    return true;
  }

  // downloadExcel(): void {
  //   const dados = this.tableData;
  //   this.uploadService.downloadTemplateUpload('BlackList', dados);
  // }


}

